// extracted by mini-css-extract-plugin
export default {"container":"recall_container__8Pr9x","select":"recall_select__PvmQG"};